import React from 'react';
import CalendlyWidget from '../components/CalendlyWidget';
import { CalendarIcon, ClockIcon, UserGroupIcon, CheckCircleIcon } from '@heroicons/react/24/outline';

const MeetingSchedulerPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              Schedule Your Meeting
            </h1>
            <p className="text-xl text-blue-100 mb-8 max-w-3xl mx-auto">
              Book a time that works for you to discuss how QuickReach Private AI can transform your business
            </p>
          </div>
        </div>
      </div>

      {/* Benefits Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-12">
          <div className="bg-white rounded-lg shadow-sm p-6 text-center">
            <CalendarIcon className="w-12 h-12 text-blue-600 mx-auto mb-4" />
            <h3 className="font-semibold text-gray-900 mb-2">Flexible Scheduling</h3>
            <p className="text-sm text-gray-600">Choose a time that fits your schedule</p>
          </div>
          
          <div className="bg-white rounded-lg shadow-sm p-6 text-center">
            <ClockIcon className="w-12 h-12 text-purple-600 mx-auto mb-4" />
            <h3 className="font-semibold text-gray-900 mb-2">30-60 Minutes</h3>
            <p className="text-sm text-gray-600">Quick consultation or in-depth discussion</p>
          </div>
          
          <div className="bg-white rounded-lg shadow-sm p-6 text-center">
            <UserGroupIcon className="w-12 h-12 text-teal-600 mx-auto mb-4" />
            <h3 className="font-semibold text-gray-900 mb-2">Expert Team</h3>
            <p className="text-sm text-gray-600">Meet with our AI solution specialists</p>
          </div>
          
          <div className="bg-white rounded-lg shadow-sm p-6 text-center">
            <CheckCircleIcon className="w-12 h-12 text-green-600 mx-auto mb-4" />
            <h3 className="font-semibold text-gray-900 mb-2">No Obligation</h3>
            <p className="text-sm text-gray-600">Free consultation with no commitments</p>
          </div>
        </div>

        {/* What to Expect */}
        <div className="bg-white rounded-xl shadow-lg p-8 mb-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center">
            What to Expect in Your Meeting
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0">
                <div className="w-8 h-8 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center font-semibold">
                  1
                </div>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900 mb-1">Understand Your Needs</h3>
                <p className="text-sm text-gray-600">We'll discuss your current challenges and business objectives</p>
              </div>
            </div>
            
            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0">
                <div className="w-8 h-8 bg-purple-100 text-purple-600 rounded-full flex items-center justify-center font-semibold">
                  2
                </div>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900 mb-1">Explore Solutions</h3>
                <p className="text-sm text-gray-600">Review our AI products and how they fit your use case</p>
              </div>
            </div>
            
            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0">
                <div className="w-8 h-8 bg-teal-100 text-teal-600 rounded-full flex items-center justify-center font-semibold">
                  3
                </div>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900 mb-1">Live Demo</h3>
                <p className="text-sm text-gray-600">See our solutions in action with a personalized demonstration</p>
              </div>
            </div>
            
            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0">
                <div className="w-8 h-8 bg-green-100 text-green-600 rounded-full flex items-center justify-center font-semibold">
                  4
                </div>
              </div>
              <div>
                <h3 className="font-semibold text-gray-900 mb-1">Next Steps</h3>
                <p className="text-sm text-gray-600">Discuss implementation, pricing, and timeline for your project</p>
              </div>
            </div>
          </div>
        </div>

        {/* Calendly Widget */}
        <div className="bg-white rounded-xl shadow-lg p-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center">
            Choose Your Time Slot
          </h2>
          <CalendlyWidget />
        </div>

        {/* Contact Alternative */}
        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-4">
            Prefer to reach out directly?
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <a 
              href="mailto:info@quickreach.ai" 
              className="inline-flex items-center px-6 py-3 bg-gray-800 text-white rounded-lg hover:bg-gray-900 transition-colors"
            >
              Email Sales Team
            </a>
            <a 
              href="mailto:demo@quickreach.ai" 
              className="inline-flex items-center px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
            >
              Request Demo
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MeetingSchedulerPage;

